<div class="compact-card">
    @if (device.type !== DeviceType3D.STOREY) {
        <div class="card-main">
            <div class="img-container">
                <img [src]="'/assets/img/overview_grid/' + (device.panelType ? device.panelType : 'HOME') + '.png'" />
            </div>
            <div class="column info" [class.extended]="!this.showBattery()">
                <web-device-type-label class="body-medium" [type]="device.panelType" [surname]="device.name" />
                <div class="row">
                    <div class="column">
                        @if (device.state === DeviceState.CONNECTED) {
                            <div class="row">
                                @if (device.production != null) {
                                    <ng-container>
                                        <div class="column">
                                            <div class="header body-medium grey">
                                                {{ 'GLOBAL.PRODUCTION' | translate }}
                                            </div>
                                            <web-fading-span
                                                valueClass="sub-headline-bold short-line-height"
                                                suffixClass="sub-headline-bold short-line-height"
                                                [value]="device.production || isMeter ? device.production : '-'"
                                                [suffix]="device.production || isMeter ? 'W' : ''"
                                                [autorizeZero]="isMeter"
                                            ></web-fading-span>
                                        </div>
                                    </ng-container>
                                }
                                @if (hasConsumption()) {
                                    @if (device.production != null) {
                                        <hr class="vertical" />
                                    }
                                    <ng-container class="column">
                                        <div class="column">
                                            <div class="header body-medium grey">
                                                {{ 'GLOBAL.CONSUMPTION_SHORT' | translate }}
                                            </div>
                                            <web-fading-span
                                                valueClass="sub-headline-bold short-line-height"
                                                suffixClass="sub-headline-bold short-line-height"
                                                [value]="device.totalDevicesConsumption ?? 0"
                                                suffix="W"
                                                [autorizeZero]="true"
                                            ></web-fading-span>
                                        </div>
                                    </ng-container>
                                }
                            </div>
                        } @else {
                            <div>
                                <div class="header body-medium grey">{{ 'GLOBAL.STATUS' | translate }}</div>
                                <web-fading-span
                                    class="sub-headline-regular small-line-height"
                                    prefixImg="solar-lost-connection.svg"
                                    value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                                    valueClass="white flex"
                                    imgClass="red flex"
                                ></web-fading-span>
                            </div>
                        }
                    </div>

                    @if (this.showBattery()) {
                        <ng-container>
                            <hr class="vertical" />

                            @if (device.batteryState) {
                                <web-batterie-icon [batterieState]="device.batteryState"></web-batterie-icon>
                            }

                            <web-energy-info
                                [label]="'GLOBAL.BATTERY' | translate"
                                [value]="device.battery"
                                color="grey"
                                suffix="%"
                                valueClass="sub-headline-bold short-line-height"
                                suffixClass="sub-headline-bold short-line-height"
                            >
                            </web-energy-info>
                        </ng-container>
                    }
                </div>
            </div>
        </div>
        @if ((device.productionPerPhase?.length ?? 0) >= 2 || (device.consumptionPerDevice?.length ?? 0) >= 2) {
            <div class="detail-section">
                @if (showDetail()) {
                    @if ((device.productionPerPhase?.length ?? 0) >= 2) {
                        @for (phase of device.productionPerPhase!; track phase.name) {
                            <hr class="horizontal" />
                            <div class="device-row">
                                <span class="device-name">{{ phase.name | translate }}</span>
                                <div class="device-power">
                                    <div class="power-label grey">
                                        <ion-icon src="assets/icon/solar-panel.svg"></ion-icon>
                                        <span class="body-medium">{{ 'GLOBAL.PRODUCTION' | translate }}</span>
                                    </div>
                                    <web-fading-span
                                        valueClass="sub-headline-bold short-line-height"
                                        suffixClass="sub-headline-bold short-line-height"
                                        [value]="phase.power ? phase.power : '-'"
                                        [suffix]="phase.power ? 'W' : ''"
                                    ></web-fading-span>
                                </div>
                            </div>
                        }
                    }
                    @if ((device.consumptionPerDevice?.length ?? 0) >= 2) {
                        @for (consumption of device.consumptionPerDevice!; track consumption.deviceName) {
                            <hr class="horizontal" />
                            <div class="device-row">
                                <span class="device-name">{{ consumption.deviceName | translate }}</span>
                                <div class="device-power">
                                    <div class="power-label grey">
                                        <ion-icon src="assets/icon/plug-charging.svg"></ion-icon>
                                        <span class="body-medium">{{ 'GLOBAL.CONSUMPTION_SHORT' | translate }}</span>
                                    </div>
                                    <web-fading-span
                                        valueClass="sub-headline-bold short-line-height"
                                        suffixClass="sub-headline-bold short-line-height"
                                        [value]="consumption.power ? consumption.power : '-'"
                                        [suffix]="consumption.power ? 'W' : ''"
                                    ></web-fading-span>
                                </div>
                            </div>
                        }
                    }
                }
                <hr class="horizontal" />
                <div class="toggle-detail-row">
                    <ion-button class="tertiary-button" fill="clear" size="small" (click)="toggleDetail()">
                        {{ (showDetail() ? 'GLOBAL.HIDE_DETAIL' : 'GLOBAL.SHOW_DETAIL') | translate }}
                    </ion-button>
                </div>
            </div>
        }
    } @else {
        <div class="card-main">
            <div class="img-container">
                <img src="/assets/img/overview_grid/STOREY.png" />
            </div>
            <div class="column info">
                <web-device-type-label class="body-medium" [type]="DeviceTypeEnum.STOREY" [surname]="device.name" />
                <div class="row">
                    @if (device.batteryState === BatteryState.INITIALIZING) {
                        <div>
                            <div class="header body-medium grey">{{ 'GLOBAL.STATUS' | translate }}</div>
                            <div class="initialize-container">
                                <ion-icon
                                    class="loader"
                                    slot="icon-only"
                                    src="assets/icon/loader.svg"
                                    color="light"
                                ></ion-icon>
                                <web-fading-span
                                    class="sub-headline-regular small-line-height"
                                    value="{{ 'GLOBAL.BATTERY_STATE.INITIALIZING' | translate }}"
                                    valueClass="white flex"
                                    suffixClass="wrap"
                                ></web-fading-span>
                            </div>
                        </div>
                    } @else if (device.batteryState === BatteryState.DEVICE_OFF) {
                        <div>
                            <div class="header body-medium grey">{{ 'GLOBAL.STATUS' | translate }}</div>
                            <web-fading-span
                                class="sub-headline-regular small-line-height"
                                prefixImg="storey-lost-connection.svg"
                                value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                                valueClass="white flex"
                                imgClass="red flex"
                            ></web-fading-span>
                        </div>
                    } @else {
                        @if (isBatteryPaused()) {
                            <div class="column">
                                <div class="header body-medium grey">
                                    {{ 'GLOBAL.STATUS' | translate }}
                                </div>
                                <div class="row info">
                                    <ion-icon
                                        class="loader"
                                        slot="icon-only"
                                        src="assets/icon/loader.svg"
                                        color="light"
                                    ></ion-icon>
                                    <div>
                                        <span> {{ 'PAGES.OVERVIEW.STOREY.PAUSE_UNTIL' | translate }} </span>
                                        <span>
                                            {{
                                                getStoreyInhibitionDate().toLocaleTimeString([], {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })
                                            }}
                                        </span>
                                        <sup class="yellow">{{ getDaysDiffToDisplay() }}</sup>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            @if (device.batteryState) {
                                <web-batterie-icon [batterieState]="device.batteryState"></web-batterie-icon>
                            }
                            <div class="column">
                                <div class="header body-medium grey">
                                    {{ 'GLOBAL.AVAILABLE' | translate }}
                                </div>
                                <div class="row info">
                                    <web-fading-span
                                        [value]="device.soc ? device.soc : '-'"
                                        [suffix]="device.soc ? '%' : ''"
                                    ></web-fading-span>
                                    <hr class="vertical" />
                                    <web-fading-span
                                        [value]="device.storedEnergyKwh ? device.storedEnergyKwh : '-'"
                                        [suffix]="device.storedEnergyKwh ? 'Wh' : '-'"
                                    ></web-fading-span>
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }
</div>
